import { requests } from "../../requests";
import { mergeProjectUrl } from "../../http/config";
import { EndPoints } from "../../utils/EndPoints";

export const duePaymentsService = {
  getAll: async (page = 1) => {
    try {
      const options = {
        method: "GET",
        url: mergeProjectUrl(EndPoints.DuePayments.list),
        params: { page },
      };
      const response = await requests(options);
      console.log("getAll response:", response.data);
      return response.data;
    } catch (error) {
      console.log("getAll error:", error);
      return {
        error: true,
        data: error.response?.data || "Error fetching due payments",
      };
    }
  },

  getAllWithNextURL: async (nextURL) => {
    try {
      const options = {
        method: "GET",
        url: nextURL,
      };
      const response = await requests(options);
      return response.data;
    } catch (error) {
      return {
        error: true,
        data: error.response?.data || "Error fetching due payments",
      };
    }
  },

  getSummary: async () => {
    try {
      const options = {
        method: "GET",
        url: mergeProjectUrl(EndPoints.DuePayments.summary),
      };
      const response = await requests(options);
      console.log("getSummary response:", response.data);
      return response.data;
    } catch (error) {
      console.log("getSummary error:", error);
      return {
        error: true,
        data: error.response?.data || "Error fetching due payments summary",
      };
    }
  },

  getMillers: async (page = 1) => {
    try {
      const options = {
        method: "GET",
        url: mergeProjectUrl(EndPoints.DuePayments.millers),
        params: { page },
      };
      const response = await requests(options);
      return response.data;
    } catch (error) {
      return {
        error: true,
        data: error.response?.data || "Error fetching miller payments",
      };
    }
  },

  getMillersWithNextURL: async (nextURL) => {
    try {
      const options = {
        method: "GET",
        url: nextURL,
      };
      const response = await requests(options);
      return response.data;
    } catch (error) {
      return {
        error: true,
        data: error.response?.data || "Error fetching miller payments",
      };
    }
  },

  getBrokers: async (page = 1) => {
    try {
      const options = {
        method: "GET",
        url: mergeProjectUrl(EndPoints.DuePayments.brokers),
        params: { page },
      };
      const response = await requests(options);
      return response.data;
    } catch (error) {
      return {
        error: true,
        data: error.response?.data || "Error fetching broker payments",
      };
    }
  },

  getBrokersWithNextURL: async (nextURL) => {
    try {
      const options = {
        method: "GET",
        url: nextURL,
      };
      const response = await requests(options);
      return response.data;
    } catch (error) {
      return {
        error: true,
        data: error.response?.data || "Error fetching broker payments",
      };
    }
  },

  calculateDiscount: (amount, discountPercentage) => {
    return (amount * discountPercentage) / 100;
  },
};

export const getPaymentStatus = (dueDate) => {
  if (!dueDate) return "pending";
  
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const due = new Date(dueDate);
  due.setHours(0, 0, 0, 0);
  const diffTime = due.getTime() - today.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays < 0) return "overdue";
  if (diffDays <= 3) return "urgent";
  return "pending";
};

export const formatCurrency = (amount, currency = "INR") => {
  if (!amount && amount !== 0) return "₹0";
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

export const formatDate = (date) => {
  if (!date) return "N/A";
  return new Date(date).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};
